import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: relative;

  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-end;

  overflow-x: hidden;
  overflow-y: auto;
`;
